import React, { useCallback, useEffect, useRef, useState } from "react";
import SearchBar from "../components/SearchBar";
import { useDetectClickOutside } from "react-detect-click-outside";
import {
  Container,
  DivBorder,
  Line,
  ModalContainer,
  InputTextArea,
  InputText,
  Warning,
  DivBorderBottom,
  SaveButton,
  SaveButtonLabel,
  ClausuleItemContainer,
  ClausuleItem,
  ClausuleLabel,
  ModalCreateClausule,
  TextShowTitle,
  LabelShowTitle,
  ModalShowClausule,
  TextContent,
  Text,
  FeaturesClauseContainer,
  FlexPagination,
  WrapperAll
} from "./styles";
import Modal from "react-modal";
import api from "../../../services/api";
import ButtonIcons from "../../../shared/components/ButtonIcons";
import StarClausesIcon from "../../editor/assets/icons/StarClausesIcon";
import EditClausesIcon from "../../editor/assets/icons/EditClausesIcon";
import exitIcon from "../../../assets/close-icon.svg";
import RemoveClausesIcon from "../../editor/assets/icons/RemoveClausesIcon";
import { toast, ToastContainer } from "react-toastify";
import Pagination from "../../../shared/components/Pagination";
import { LoadingFlex } from "../../login/pages/Login/styles";
import LoadingEditor from "../../editor/components/LoadingEditor";
import { useMainHook } from "../../../hooks/main";
import { relative } from "path";
import { TextEmpy } from "../../myAutomations/screen/styles";
import { ContractAnimation } from "../../../shared/components/ContractAnimation";

const modalStyleCreateClausule = {
  content: {
    padding: 0,
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "85%",
    borderRadius: 20
  },
  overlay: {
    background: "rgba(26, 26, 26, 0.95)"
  }
};

const modalStyleShowClausule = {
  content: {
    padding: 0,
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "60%",
    borderRadius: 10
  },
  overlay: {
    background: "rgba(26, 26, 26, 0.95)"
  }
};

interface MyClausesDataProps {
  clause: string;
  created_at: string;
  description?: string;
  id: string;
  is_favorite: boolean;
  key_words?: string;
  title: string;
  updated_at: string;
  user_id: string;
}

interface ObjectNewClause {
  user_clause_id?: string;
  title: string;
  clause: string;
  description: string;
  is_favorite: boolean;
  key_words?: string;
}

interface QueryProps {
  search?: string;
  filter?: string;
  pagination?: number;
}

interface MyClauseObjectProps {
  user_clause_id: string;
  title: string;
  clause: string;
  description: string;
  is_favorite: boolean;
  key_words?: string;
}

const MyClausules: React.FC = () => {
  const { isModalCreateClause, setIsModalCreateClause } = useMainHook();
  const [modalIsOpen, setIsModalOpen] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const refInputSearch = useRef<HTMLInputElement>(null);
  const [loading, setLoading] = useState(true);
  const [activeModal, setActiveModal] = useState<
    "showClausules" | "createClausules" | "editClausules"
  >();
  const [clauses, setClauses] = useState<MyClausesDataProps[]>([]);
  const [newObjectClause, setNewObjectClause] = useState<ObjectNewClause>({
    title: "",
    clause: "",
    description: "Clause by user",
    is_favorite: false,
    key_words: ""
  });

  const [query, setQuery] = useState<QueryProps>({
    search: "",
    filter: "",
    pagination: 0
  });

  const [activeClausule, setActiveClausule] = useState<ObjectNewClause>({
    user_clause_id: "",
    title: "",
    clause: "",
    description: "Clause by user",
    is_favorite: false
  } as ObjectNewClause);

  const [visibilityFeatures, setVisibilityFeatures] = useState({
    visible: false,
    index: 0
  });

  const closeToggle = useCallback(() => {}, []);

  const [refreshClauses, setRefreshClauses] = useState(false);
  const refOutsideClick = useDetectClickOutside({ onTriggered: closeToggle });

  let subtitle;

  const handleVisibilityActive = useCallback(
    (visible: boolean, index: number) => {
      setVisibilityFeatures({
        visible,
        index
      });
    },
    []
  );

  function openModal() {
    setIsModalOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#f00";
  }

  function closeModal() {
    setIsModalOpen(false);
  }

  const handleShowClausule = (item: MyClausesDataProps, index?: number) => {
    setActiveModal("showClausules");
    setActiveClausule({
      user_clause_id: item.id,
      title: item.title,
      clause: item.clause,
      description: "Created by user",
      is_favorite: item.is_favorite
    });
    setIsModalOpen(true);
  };

  const handleEditClausule = (item: MyClausesDataProps, index?: number) => {
    setActiveModal("editClausules");
    setActiveClausule({
      user_clause_id: item.id,
      title: item.title,
      clause: item.clause,
      description: "Created by user",
      is_favorite: item.is_favorite
    });
    setIsModalOpen(true);
  };

  const handleCreateNewClausule = () => {
    setActiveModal("createClausules");
    setIsModalOpen(true);
  };

  useEffect(() => {
    const autoLoadMyClauses = async () => {
      try {
        const responseMyClauses = await api.get("user-clause", {
          params: {
            search: query.search === "" ? null : query.search,
            filter: query.filter === "" ? null : query.filter,
            pagination: query.pagination
          }
        });
        setClauses(responseMyClauses.data.dataArray);
        setTotalPages(responseMyClauses.data.pagination);
        setLoading(false);
      } catch (err) {
        console.log(err, "error when fetch myclauses of user");
        setLoading(false);
      }
    };

    autoLoadMyClauses();
  }, [refreshClauses, query]);

  const handleRemoveClause = useCallback(
    async (id: string) => {
      try {
        const responseRemoveClause = await api.delete(`user-clause/${id}`);
        setRefreshClauses(!refreshClauses);
      } catch (err) {
        console.log(err, "error when remove clause");
      }
    },
    [refreshClauses]
  );

  const onChangeNewClauses = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      setNewObjectClause(state => {
        return {
          ...state,
          title: event.target.value
        };
      });
    },
    []
  );

  const onChangeClauseText = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      setNewObjectClause(state => {
        return {
          ...state,
          clause: event.target.value
        };
      });
    },
    []
  );

  const onChangeSearchQuery = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      setQuery(state => {
        return {
          ...state,
          search: event.target.value
        };
      });
    },
    []
  );

  const onChangeTitleWhenEdit = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      setActiveClausule(state => {
        return {
          ...state,
          title: event.target.value
        };
      });
    },
    [activeClausule]
  );

  const onChangeClauseWhenEdit = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      setActiveClausule(state => {
        return {
          ...state,
          clause: event.target.value
        };
      });
    },
    [activeClausule]
  );

  const handleFavoriteClause = useCallback(
    async (idClause: string, isFavorite: boolean) => {
      let myClause: MyClauseObjectProps = {
        user_clause_id: "",
        title: "",
        clause: "",
        description: "",
        is_favorite: false,
        key_words: ""
      };

      try {
        const responseSpecifiClause = await api.get(`user-clause/${idClause}`);
        const { clause, id, title, description, key_words } =
          responseSpecifiClause.data as MyClausesDataProps;
        myClause.user_clause_id = id;
        myClause.description = description;
        myClause.clause = clause;
        myClause.title = title;
        myClause.is_favorite = !isFavorite;
        myClause.key_words = key_words ? key_words : undefined;
      } catch (err) {
        console.log(err, "ERROR when update favorite clause");
      }

      if (myClause.user_clause_id) {
        try {
          const responseMakeClauseFavorite = await api.put(
            "user-clause",
            myClause
          );

          setRefreshClauses(!refreshClauses);
        } catch (err) {
          console.log(err, "error when update effective for boolean favorite");
        }
      }
    },
    [newObjectClause, refreshClauses]
  );

  const handleEditingClauseSpecific = useCallback(async () => {
    try {
      const responseEditClause = await api.put("user-clause", activeClausule);
      setIsModalOpen(false);
      setRefreshClauses(!refreshClauses);
      toast.success("Clausula editada com sucesso!");
    } catch (err) {
      console.log(err, "error when update clause user");
      toast.error("Ops, algo deu errado!");
    }
  }, [activeClausule, modalIsOpen, refreshClauses]);

  const handleNewClause = useCallback(async () => {
    try {
      const responseCreateClause = await api.post("user-clause", {
        title: newObjectClause.title,
        clause: newObjectClause.clause,
        description: newObjectClause.description,
        is_favorite: false,
        key_words: newObjectClause.key_words
          ? newObjectClause.key_words
          : undefined
      });
      toast.success("Clausula cadastrada com sucesso!");
      setRefreshClauses(!refreshClauses);
      setIsModalOpen(false);
    } catch (err) {
      console.log(err, "error when created new clause");
      toast.error("Ops, algo deu errado!");
    }
  }, [newObjectClause]);

  //fixing one conflict with zIndex
  useEffect(() => {
    if (modalIsOpen) {
      setIsModalCreateClause(true);
    } else {
      setIsModalCreateClause(false);
    }
  }, [modalIsOpen]);

  return (
    <WrapperAll>
      {loading ? (
        <LoadingFlex>
          <ContractAnimation />
        </LoadingFlex>
      ) : (
        <>
          {isModalCreateClause && (
            <img
              className="absolute-icon-exit"
              src={exitIcon}
              onClick={() => setIsModalOpen(false)}
              alt=""
            />
          )}
          <Container>
            <ToastContainer position="bottom-left" />
            <span className="heading">Minha biblioteca</span>
            <SearchBar
              value={query.search}
              onChange={onChangeSearchQuery}
              onClickSearchButton={handleCreateNewClausule}
              query={query}
              setQuery={setQuery}
            />
            <ClausuleItemContainer>
              {clauses.map((item, index) => {
                return (
                  <ClausuleItem
                    onMouseEnter={() => handleVisibilityActive(true, index)}
                    onMouseLeave={() => handleVisibilityActive(false, index)}
                  >
                    <ClausuleLabel onClick={() => handleShowClausule(item)}>
                      {item.title}
                    </ClausuleLabel>

                    {visibilityFeatures.visible &&
                      visibilityFeatures.index === index && (
                        <FeaturesClauseContainer>
                          <ButtonIcons
                            width="30px"
                            onClick={() =>
                              handleFavoriteClause(item.id, item.is_favorite)
                            }
                          >
                            <StarClausesIcon isActive={item.is_favorite} />
                          </ButtonIcons>
                          <ButtonIcons
                            onClick={() => handleEditClausule(item)}
                            margin="0 0 0 10px"
                            width="30px"
                          >
                            <EditClausesIcon />
                          </ButtonIcons>
                          <ButtonIcons
                            onClick={() => handleRemoveClause(item.id)}
                            margin="0 0 0 10px"
                            width="30px"
                          >
                            <RemoveClausesIcon />
                          </ButtonIcons>
                        </FeaturesClauseContainer>
                      )}
                  </ClausuleItem>
                );
              })}

              {clauses.length === 0 && (
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <TextEmpy>Nenhum texto foi encontrado.</TextEmpy>
                </div>
              )}
            </ClausuleItemContainer>
            <div
              style={{ width: "100%", height: "100px", position: "relative" }}
            ></div>
            <Modal
              isOpen={modalIsOpen}
              onAfterOpen={afterOpenModal}
              onRequestClose={closeModal}
              style={
                activeModal === "showClausules"
                  ? modalStyleShowClausule
                  : activeModal === "createClausules"
                  ? modalStyleCreateClausule
                  : modalStyleShowClausule
              }
              contentLabel="Example Modal"
            >
              {activeModal === "createClausules" && (
                <ModalCreateClausule>
                  <ModalContainer>
                    <InputText
                      placeholder="TÍTULO"
                      value={newObjectClause?.title}
                      onChange={onChangeNewClauses}
                    />
                    <Line />

                    <InputText
                      placeholder="PALAVRAS CHAVE (exemplo: multa; rescisão)"
                      value={newObjectClause?.key_words}
                      onChange={e =>
                        setNewObjectClause(state => {
                          return {
                            ...state,
                            key_words: e.target.value
                          };
                        })
                      }
                    />
                    <Line />
                    <DivBorder>
                      <InputTextArea
                        placeholder="Digite sua cláusula."
                        value={newObjectClause.clause}
                        onChange={onChangeClauseText}
                      />
                    </DivBorder>
                    <DivBorderBottom>
                      <Warning>
                        Não coloque nenhuma informação confidencial de cliente
                        ao redigir esta cláusula pois ela será adicionada ao
                        banco de cláusulas. Coloque informações confidenciais de
                        clientes apenas no modelo de documento que você está
                        criando.
                      </Warning>
                    </DivBorderBottom>
                    <SaveButton onClick={handleNewClause}>
                      <SaveButtonLabel>Salvar</SaveButtonLabel>
                    </SaveButton>
                  </ModalContainer>
                </ModalCreateClausule>
              )}

              {activeModal === "showClausules" && (
                <ModalShowClausule>
                  <ModalContainer>
                    <LabelShowTitle>{activeClausule?.title}</LabelShowTitle>
                    <Line
                      style={{
                        backgroundColor: "#A5A5A5"
                      }}
                    />
                    <DivBorder>
                      <TextShowTitle>{activeClausule.clause}</TextShowTitle>
                    </DivBorder>
                    <SaveButton
                      onClick={() => {
                        setActiveModal("editClausules");
                      }}
                    >
                      <SaveButtonLabel>Editar</SaveButtonLabel>
                    </SaveButton>
                  </ModalContainer>
                </ModalShowClausule>
              )}

              {activeModal === "editClausules" && (
                <ModalShowClausule>
                  <ModalContainer>
                    <InputText
                      placeholder="Digite sua cláusula."
                      defaultValue={activeClausule.title}
                      value={activeClausule.title}
                      onChange={onChangeTitleWhenEdit}
                    />

                    <Line
                      style={{
                        backgroundColor: "#A5A5A5"
                      }}
                    />
                    <DivBorder>
                      <InputTextArea
                        placeholder="Digite sua cláusula."
                        defaultValue={activeClausule.clause}
                        value={activeClausule.clause}
                        onChange={onChangeClauseWhenEdit}
                      />
                    </DivBorder>
                    <SaveButton>
                      <SaveButtonLabel onClick={handleEditingClauseSpecific}>
                        Salvar edição
                      </SaveButtonLabel>
                    </SaveButton>
                  </ModalContainer>
                </ModalShowClausule>
              )}
            </Modal>
          </Container>
        </>
      )}
      {clauses.length > 0 && !loading && (
        <FlexPagination>
          <Pagination
            total={totalPages}
            offset={query.pagination}
            setDataParams={setQuery}
            dataParams={query}
          />
        </FlexPagination>
      )}
    </WrapperAll>
  );
};

export default MyClausules;
